import React from 'react';
import cn from 'classnames';

import {IAddressProps} from './IAddress';
import {AddressActions, AddressAttributes} from './Subcomponents';

import styles from './Address.module.scss';

const Address = ({classNames, children}: IAddressProps) => {
	return <div className={cn('address', classNames, styles['address'])}>{children}</div>;
};

Address.Attributes = AddressAttributes;
Address.Actions = AddressActions;

export default Address;
